import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OrganisationSettingsRoutes } from '@settings/settings.routes';
import { PageTitleComponent } from '@shared/components/sections/page-title/page-title.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { IStepNavigatorConfig, StepDisplay, StepModes, StepUI } from '@shared/models/step-navigator';

@Component({
	selector: 'app-settings-organisation',
	imports: [CommonModule, PageTitleComponent, RouterOutlet, StepNavigatorComponent],
	templateUrl: './settings-organisation.component.html',
	styleUrl: './settings-organisation.component.scss',
})
export class SettingsOrganisationComponent {
	stepConfig: IStepNavigatorConfig = {
		ui: StepUI.WIZARD,
		mode: StepModes.ROUTER_OUTLET,
		displayType: StepDisplay.AUTO,
		showStepChevrons: false,
		showStepNumbers: false,
		showNavButtons: true,
		steps: [
			{
				icon: 'bi-clock',
				title: {
					full: 'Business Hours',
					tabs: 'Business Hours',
				},
				route: [OrganisationSettingsRoutes.BUSINESS_HOURS],
			},
			{
				icon: 'bi-backpack',
				title: {
					full: 'Service Types',
					tabs: 'Service Types',
				},
				route: [OrganisationSettingsRoutes.SERVICE_TYPES],
			},
			{
				icon: 'bi-ui-checks',
				title: {
					full: 'Assessment Form',
					tabs: 'Assessment Form',
				},
				route: [OrganisationSettingsRoutes.ASSESSMENT_FORM],
			},
			{
				icon: 'bi-link',
				title: {
					full: 'Leads Link',
					tabs: 'Leads Link',
				},
				route: [OrganisationSettingsRoutes.LEADS_LINK],
			},
		],
	};
}
